import React from 'react';
import PropTypes from 'prop-types';
import { Trans } from '@lingui/react';

// TODO: group with other students lists in './components/students-lists'? BA 2020-01-14
function EmptyDataMessage(props) {
    const {
        hasContentLoaded,
        classesLength,
        colSpan,
        showInitialAddMessage,
        initialMessage
    } = props;

    // To ensure that no unnecessary messages are shown, just display an empty span
    if (hasContentLoaded === false) {
        return <tr><td /></tr>;
    }

    if (showInitialAddMessage === true) {
        return (
            <tr>
                <td colSpan={colSpan} className="table__cell table__cell--no-results">
                    <p>
                        {initialMessage}
                    </p>
                </td>
            </tr>
        );
    }

    // Otherwise render the appropriate messages, depending on the state
    if (classesLength === 0) {
        return (
            <tr>
                <td colSpan={colSpan} className="table__cell table__cell--no-results">
                    <p>
                        <Trans id={'Empty Data Message - No Classes - Title'} />
                    </p>
                    <p>
                        <Trans id={'Empty Data Message - No Classes - Message'} />
                    </p>
                </td>
            </tr>
        );
    }

    return (
        <tr>
            <td colSpan={colSpan} className="table__cell table__cell--no-results">
                <p>
                    <Trans id={'Empty Data Message - No Students - Message'} />
                </p>
            </td>
        </tr>
    );
}

EmptyDataMessage.defaultValue = {
    colSpan: 1
};

EmptyDataMessage.propTypes = {
    hasContentLoaded: PropTypes.bool,
    showInitialAddMessage: PropTypes.bool,
    initialMessage: PropTypes.object,
    classesLength: PropTypes.number,
    colSpan: PropTypes.number
};

export default EmptyDataMessage;



// WEBPACK FOOTER //
// ./components/empty-data-message/empty-data-message.js